Ext.define('SA.view.HistoricalToggle', {
    alias: 'widget.historical-toggle',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-historical-toggle',

    items: [
        {
            xtype: 'sa-checkbox',
            cls: 'sa-historical-toggle-checkbox'
        }, {
            xtype: 'component',
            cls: 'sa-historical-toggle-label',
            itemId: 'label',
            html: 'Create a historical view for geographic years:&nbsp;'
        }, {
            xtype: 'component',
            autoEl: {tag: 'a', href: '#'},
            cls: 'sa-historical-toggle-year-link',
            itemId: 'year',
            tpl: '{.}'
        }
    ],

    initComponent() {
        this.callParent();

        this.checkbox = this.down('sa-checkbox');
        this.label = this.down('#label');
        this.yearLink = this.down('#year');

        this.setSelectedHistoricalRelease(this.country.getLatestHistoricalCensusRelease());
    },

    getSelectedRelease() {
        if (this.isEnabled() && this.checkbox.isChecked()) {
            return this.selectedHistoricalRelease;
        }

        return this.country.getLatestCensusRelease();
    },

    initEvents() {
        this.callParent();

        this.checkbox.on('change', this.onChangeCheckbox, this);
        this.label.el.on('click', this.onClickLabel, this);
        this.yearLink.el.on('click', this.onClickYearLink, this, {preventDefault: true});
    },

    isChecked() {
        return this.checkbox.isChecked();
    },

    isEnabled() {
        return this.isVisible();
    },

    onChangeCheckbox(checkbox, checked) {
        this.fireEvent('change:checkbox', checked);
    },

    onClickLabel() {
        this.checkbox.setChecked(!this.checkbox.isChecked());
    },

    onClickYearLink() {
        var country = this.country.getCode(),
            selectedRelease = this.selectedHistoricalRelease,
            listeners = {'click:ok': this.onWinOkClick, scope: this};

        Ext.widget({xtype: 'census-release-window', country, selectedRelease, listeners});
    },

    onWinOkClick(win, historicalRelease) {
        win.destroy();

        this.checkbox.setChecked(true);
        this.setSelectedHistoricalRelease(historicalRelease);
    },

    setEnabled(enabled) {
        this.setVisible(enabled);
    },

    setSelectedHistoricalRelease(historicalRelease) {
        this.selectedHistoricalRelease = historicalRelease;
        this.yearLink.update(this.country.getCensusReleaseRange(historicalRelease).join('–'));

        this.fireEvent('select:release', historicalRelease);
    }
});